import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
const { Option } = Select;

function ApprovalsFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      props.filterBy?.type &&
        form.setFields([{ name: "type", value: props.filterBy?.type }]);
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    form.resetFields();
  }

  const onFinish = (values) => {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  };
  return (
    <Modal
      title="Filter Approvals"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="approvalFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Type" name="type">
          <Select placeholder="Select type">
            <Option key={"user"} value={"user"}>
              User
            </Option>
            <Option key={"designation"} value={"designation"}>
              Designation
            </Option>
            <Option key={"plan"} value={"plan"}>
              Plan
            </Option>
            <Option key={"unit"} value={"unit"}>
              Unit
            </Option>
          </Select>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ApprovalsFilterModal;
